import React, { memo } from 'react';
import { styled } from '@mui/material/styles';
import { MenuItem as MaterialMenuItem } from '@mui/material';
import { Icon } from 'modules/ui';
import { Colors } from 'modules/theme';

const StyledListItem = styled(MaterialMenuItem)(() => ({
  minHeight: 39,
  textDecoration: 'none!important',
  fontSize: '14px',
  lineHeight: '24px',
  alignItems: 'center',
  color: Colors.darkBlue,
}));

const styles = {
  active: {
    fontWeight: 'bold',
  },
};

function MenuItem({
  text,
  icon,
  iconSize = 16,
  iconColor = Colors.grayishBlue,
  iconStyle,
  onClick,
  disabled,
  active,
  textStyle = {},
}) {
  const style = active ? styles.active : null;
  return (
    <StyledListItem onClick={onClick} disabled={disabled}>
      {icon && (
        <Icon
          className="mr-12"
          name={icon}
          color={iconColor}
          size={iconSize}
          style={iconStyle}
        />
      )}
      <div style={{ ...style, ...textStyle }}>{text}</div>
    </StyledListItem>
  );
}

export default memo(MenuItem);
